(() => {
  if (customElements.get('layout-control')) {
    return;
  }

  class LayoutControl extends HTMLElement {
    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();

      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
      this.updateLayoutCSSVariable();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.buttons.forEach(button => button.addEventListener('click', this.onButtonClick));
    }

    detachEvents() {
      this.buttons.forEach(button => button.removeEventListener('click', this.onButtonClick));
    }

    init() {
      this.buttons = this.querySelectorAll('button');
    }

    onButtonClick(event) {
      const target = event.currentTarget;

      this.buttons.forEach(button => {
        const isActive = button === target;

        button.classList.toggle(LayoutControl.ACTIVE_CLASS, isActive);
        button.setAttribute('aria-pressed', isActive);
      });

      this.updateLayoutCSSVariable(target.dataset.layout);
    }

    updateLayoutCSSVariable(layout = '1fr') {
      document.documentElement.style.setProperty('--layout-grid-items', layout);
    }
  }

  customElements.define('layout-control', LayoutControl);
})();
